<div
  class="item-list-row"
  [class.item-list-row--selected]="selected"
  role="button"
  tabindex="0"
  [attr.aria-pressed]="selected || null"
  (click)="onActivate()"
  (keydown.enter)="onActivate()"
  (keydown.space)="$event.preventDefault(); onActivate()">

  @if (showDot) {
    <span
      class="item-list-row__dot"
      [class.item-list-row__dot--success]="tone === 'success'"
      [class.item-list-row__dot--warning]="tone === 'warning'"
      [class.item-list-row__dot--error]="tone === 'error'"
      [class.item-list-row__dot--pulse]="pulse"
      aria-hidden="true"></span>
  }

  <ng-content select="[itemIcon]"></ng-content>

  <div class="item-list-row__body">
    <ng-content select="[itemBody]"></ng-content>
  </div>

  <ng-content select="[itemTrailing]"></ng-content>
</div>
